import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { UrgencyBanner } from '../components/UrgencyBanner';
import { MarqueeBanner } from '../components/MarqueeBanner';
import { HeroSection } from '../components/HeroSection';
import { FormulaSection } from '../components/FormulaSection';
import { LogrosSection } from '../components/LogrosSection';
import { ModeloNegocioSection } from '../components/ModeloNegocioSection';
import { CaseStudySection } from '../components/CaseStudySection';
import { AlumnosSection } from '../components/AlumnosSection';
import { CourseContentSection } from '../components/CourseContentSection';
import { TestimonialsBanner } from '../components/TestimonialsBanner';
import { TestimonialsFeatures } from '../components/TestimonialsFeatures';
import { BonusSection } from '../components/BonusSection';
import { FAQ2Section } from '../components/FAQ2Section';
import { TestimonialsMasonrySection } from '../components/TestimonialsMasonrySection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FinalCTASection } from '../components/FinalCTASection';
export function LandingPage() {
  useEffect(() => {
    document.title = 'Emprende Digital';
    // Update meta tags for link sharing
    const setMeta = (property: string, content: string) => {
      let tag = document.querySelector(`meta[property="${property}"]`) || document.querySelector(`meta[name="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        if (property.startsWith('og:')) {
          tag.setAttribute('property', property);
        } else {
          tag.setAttribute('name', property);
        }
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('description', 'Emprende Digital - Generá ingresos extra vendiendo por internet desde cero');
    setMeta('og:title', 'Emprende Digital');
    setMeta('og:description', 'Generá ingresos extra vendiendo por internet desde cero');
    setMeta('og:type', 'website');
  }, []);
  return <main className="w-full min-h-screen bg-brand-bg overflow-x-hidden" data-id="element-560">
      <MarqueeBanner data-id="element-561" />
      <UrgencyBanner data-id="element-562" />
      <HeroSection data-id="element-563" />

      <CaseStudySection data-id="element-564" />
      <AlumnosSection data-id="element-565" />
      <TestimonialsBanner data-id="element-566" />
      <TestimonialsFeatures data-id="element-567" />
      <LogrosSection data-id="element-568" />
      <CourseContentSection data-id="element-569" />
      <ModeloNegocioSection data-id="element-570" />
      <BonusSection data-id="element-571" />
      <PricingSection data-id="element-572" />
      <motion.div className="w-full bg-brand-bg py-10 text-center" initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} data-id="element-573">
        <a href="#pricing" onClick={e => {
        e.preventDefault();
        document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} className="inline-block bg-brand-green hover:bg-brand-green-hover text-white font-bold text-lg px-10 py-4 rounded-xl transition-colors duration-200 shadow-lg shadow-brand-green/20 cursor-pointer" data-id="element-574">
          🔥 Empezar Ahora
        </a>
      </motion.div>
      <TestimonialsSection data-id="element-575" />
      <TestimonialsMasonrySection data-id="element-576" />
      <FAQ2Section data-id="element-577" />
      <FinalCTASection data-id="element-578" />
    </main>;
}